import { render, staticRenderFns } from "./JitsiIntegration.vue?vue&type=template&id=0db9825e&scoped=true&"
import script from "./JitsiIntegration.vue?vue&type=script&lang=js&"
export * from "./JitsiIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9825e",
  null
  
)

export default component.exports